// StarRating component to display a star-based rating system
const StarRating = ({ rating, maxRating = 5 }) => {
  const roundedRating = Math.round(rating);

  return (
    <div className="flex gap-1">
      {[...Array(maxRating)].map((_, i) => (
        <i
          key={i}
          className={`pi ${
            i < roundedRating
              ? "pi-star-fill text-primary-default"
              : "pi-star text-gray-300"
          }`}
        ></i>
      ))}
    </div>
  );
};

export default StarRating;
